/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, PopoverController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../../app/globals';
import { SessionProvider } from '../../../../providers/session';
import { Market_SessionInstrumentStore } from '../sessionInstrument.store';

@Component({
  selector: 'page-market-sessionInstrument-trades',
  templateUrl: 'trades.html'
})
export class Market_SessionInstrumentTradesPage {
  @ViewChild(Content) private content: Content;
  constructor(
    // *** System
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private store: Market_SessionInstrumentStore) {
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/sessionInstrument/trades/trades.ts